"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isPageEditor = function isPageEditor() {
  return document.querySelector('body').classList.contains('on-page-editor');
};

var _default = isPageEditor;
exports["default"] = _default;